<template>
  <b-overlay
    :show="loading"
  >
    <b-card
      title="ایجاد سوال"
    >
      <b-row align-h="center">

        <b-col md="10">
          <b-card
            title="شرط نمایش سوال"
            border-variant="dark"
          >
            <b-card-body>
              <b-row>
                <b-col md="4">
                  <p>
                    <b-form-checkbox
                        v-model="check.DietType"
                    >
                      نوع
                    </b-form-checkbox>
                  </p>
                  <b-form-group >
                    <v-select
                        v-model="form.DietType"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        :options="enums('DietType')"
                        :disabled="!check.DietType"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <p>
                    <b-form-checkbox
                      v-model="check.Height"
                    >
                      قد
                    </b-form-checkbox>
                  </p>
                  <b-form-group :disabled="!check.Height">
                    <div
                      class="d-flex  justify-content-around"
                      style="width:fit-content"
                    >
                      <div>
                        <b-input-group
                          prepend="از"
                        >
                          <b-form-input v-model="form.ToHeight" />
                        </b-input-group>
                      </div>
                      <div>
                        <b-input-group
                          prepend="تا"
                        >
                          <b-form-input v-model="form.FromHeight" />
                        </b-input-group>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <p>
                    <b-form-checkbox
                      v-model="check.Weight"
                    >
                      وزن
                    </b-form-checkbox>
                  </p>
                  <b-form-group :disabled="!check.Weight">
                    <div
                      class="d-flex  justify-content-around"
                      style="width:fit-content"
                    >
                      <div>
                        <b-input-group
                          prepend="از"
                        >
                          <b-form-input v-model="form.FromWeight" />
                        </b-input-group>
                      </div>
                      <div>
                        <b-input-group
                          prepend="تا"
                        >
                          <b-form-input v-model="form.ToWeight" />
                        </b-input-group>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <p>
                    <b-form-checkbox
                      v-model="check.Wrist"
                    >
                      مچ
                    </b-form-checkbox>
                  </p>
                  <b-form-group :disabled="!check.Wrist">
                    <div
                      class="d-flex  justify-content-around"
                      style="width:fit-content"
                    >
                      <div>
                        <b-input-group
                          prepend="از"
                        >
                          <b-form-input v-model="form.FromWrist" />
                        </b-input-group>
                      </div>
                      <div>
                        <b-input-group
                          prepend="تا"
                        >
                          <b-form-input v-model="form.ToWrist" />
                        </b-input-group>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <p>
                    <b-form-checkbox
                      v-model="check.Age"
                    >
                      سن
                    </b-form-checkbox>
                  </p>
                  <b-form-group :disabled="!check.Age">
                    <div
                      class="d-flex  justify-content-around"
                      style="width:fit-content"
                    >
                      <div>
                        <b-input-group
                          prepend="از"
                        >
                          <b-form-input v-model="form.FromAge" />
                        </b-input-group>
                      </div>
                      <div>
                        <b-input-group
                          prepend="تا"
                        >
                          <b-form-input v-model="form.ToAge" />
                        </b-input-group>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-checkbox
                    v-model="check.Gender"
                  >
                    جنسیت
                  </b-form-checkbox>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.Gender"
                      :options="enums('Gender')"
                      class="mt-1"
                      :disabled="!check.Gender"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <p>
                    <b-form-checkbox
                      v-model="check.Sickness"
                    >
                      بیماری
                    </b-form-checkbox>
                  </p>
                  <b-form-group>
                    <Sickness
                      v-model="form.SicknessIds"
                      :multiple="true"
                      :disabled="!check.Sickness"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col md="2">
                  <p>
                    <b-form-checkbox
                      v-model="check.Activity"
                    >
                      سطح فعالیت
                    </b-form-checkbox>
                  </p>
                  <b-form-group>
                    <v-select
                      v-model="form.ActivityLevel"
                      :options="enums('ActivityLevel')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                      :disabled="!check.Activity"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <b-card
            title="تنظیمات سوال"
            border-variant="dark"
          >
            <b-card-body>
              <b-row>
                <b-col md="2">
                  <b-form-group
                      label="وضعیت"
                      label-for="IsLock"
                  >
                    <v-select
                        v-model="form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :reduce="x => x.value"
                        :clearable="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      label="الویت"
                      label-for="Sort"
                  >
                    <b-form-input
                        id="Sort"
                        v-model="form.Sort"
                        autocomplete="off"
                        type="number"
                        name="Sort"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="نوع سوال">
                    <v-select
                      v-model="form.Type"
                      :options="enums('questionType')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="لزوم  پاسخگویی">
                    <b-form-radio-group
                      v-model="form.IsRequired"
                      :options="enums('requiredness')"
                      class="mt-1"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <b-row>
            <b-col md="12">
              <b-form-group
                label="سوال"
              >
                <b-form-textarea v-model="form.Title" />
              </b-form-group>
            </b-col>
          </b-row>
          <draggable
              v-model="form.QuestionOption"
              tag="ul"
              class="list-group list-group-flush cursor-move"
          >
          <b-row v-for="(answer,index) in form.QuestionOption" tag="li"
                 class="mb-1">
            <b-col md="11" class="question-option">
              <b-form-group label="گزینه">
                <feather-icon
                    class="mr-1"
                    icon="MoreVerticalIcon"
                    size="16"
                />
                <b-form-input v-model="answer.Title" class="w-100" />
              </b-form-group>
            </b-col>
            <b-col
              md="1"
              align-self="end"
              class="mb-1 text-right"
            >
              <trash
                v-model="form.QuestionOption"
                :index="index"
              />
            </b-col>
          </b-row>
          </draggable>
          <b-row>
            <b-col>
              <feather-icon
                class="btn-icon btn-outline-info cursor-pointer"
                icon="PlusIcon"
                size="24"
                @click="form.QuestionOption.push({     Title: null,   })"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-1 mb-2 text-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-1"
                @click="save"
              >
                ذخیره
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                @click="back"
              >
                بازگشت
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import Sickness from '@/tools/sickness.vue'
import draggable from 'vuedraggable'

export default {
  name: 'AddDedicatedDietQuestion',
  components: {
    Sickness,
    draggable,
  },
  data() {
    return {
      loading: false,
      form: {
        Title: null,
        Type: 0,
        IsRequired: true,
        Gender: null,
        FromAge: null,
        ToAge: null,
        FromHeight: null,
        ToHeight: null,
        FromWeight: null,
        ToWeight: null,
        FromWrist: null,
        ToWrist: null,
        ActivityLevel: null,
        DietMethod: null,
        SicknessIds: [],
        QuestionOption: [],
        IsActive: true
      },
      check: {
        Age: false,
        Height: false,
        Weight: false,
        Wrist: false,
        Gender: false,
        Sickness: false,
        Activity: false,
      },
      url: '',
    }
  },
  watch: {
    'check.Age': function (val) {
      if (!val) {
        this.form.FromAge = null
        this.form.ToAge = null
      }
    },
    'check.Height': function (val) {
      if (!val) {
        this.form.FromHeight = null
        this.form.ToHeight = null
      }
    },
     'check.DietType': function (val) {
      if (!val) {
        this.form.DietType = null
        this.form.DietType = null
      }
    },

    'check.Weight': function (val) {
      if (!val) {
        this.form.FromWeight = null
        this.form.ToWeight = null
      }
    },
    'check.Wrist': function (val) {
      if (!val) {
        this.form.FromWrist = null
        this.form.ToWrist = null
      }
    },
    'check.Gender': function (val) {
      if (!val) {
        this.form.Gender = null
      }
    },
    'check.Sickness': function (val) {
      if (!val) {
        this.form.SicknessIds = []
      }
    },
    'check.Activity': function (val) {
      if (!val) {
        this.form.ActivityLevel = []
      }
    },
  },
  created() {
    if (this.$route.params.QuestionID) {
      this.form.Id = this.$route.params.QuestionID
      this.url = this.$api.question.update
      this.get()
    } else {
      this.url = this.$api.question.add
    }
  },
  methods: {
    get() {
      this.loading = true
      this.$http.post(this.$api.question.get, { Id: this.form.Id }).then(response => {
        this.loading = false
        this.form = response.data
        this.TickCheckBox()
      })
    },
    save() {
      this.loading = true

      this.form.QuestionOption.forEach((item, index) => {
        this.$set(item, 'Sort', index)
      })

      this.$http.post(this.url, this.form).then(response => {
        this.back()
      }).finally(() => {
        this.loading = false
      })
    },
    TickCheckBox() {
      Object.keys(this.check).forEach(checkKey => {
        Object.keys(this.form).forEach(formKey => {
          if (formKey.includes(checkKey) && this.form[formKey] !== null) {
            if (Array.isArray(this.form[formKey])) {
              if (this.form[formKey].length > 0) this.check[checkKey] = true
            } else this.check[checkKey] = true
          }
        })
      })
    },
  },
}
</script>

<style>
.question-option div{
  display: flex;
}
</style>
